/* ── emmera-typewriter.js ───────────────────────────────────────────────── */

class EmmeraTypewriter {
  constructor(el, options = {}) {
    this.el      = el;
    this.speed   = options.speed   ?? 80;
    this.onDone  = options.onDone  ?? null;
    this.text    = el.textContent.trim();
    this.el.textContent = '';
  }

  async write() {
    this.el.classList.add('emm-tw-active');
    for (const char of this.text) {
      this.el.textContent += char;
      await this._delay(this.speed);
    }
    setTimeout(() => {
      this.el.classList.remove('emm-tw-active');
      if (this.onDone) this.onDone();
    }, 800);
  }

  _delay(ms) { return new Promise(r => setTimeout(r, ms)); }
}

/* ── CounterScroll : défile -5% → -10% → -15% ─── */
class EmmeraCounterScroll {
  constructor(el, items = ['-5%', '-10%', '-15%'], interval = 2000) {
    this.el       = el;
    this.items    = items;
    this.current  = 0;
    this.interval = interval;
  }

  start() {
    this.el.textContent = this.items[0];
    setInterval(() => {
      this.current = (this.current + 1) % this.items.length;
      this.el.classList.remove('emm-cs-change');
      void this.el.offsetWidth; // reflow
      this.el.textContent = this.items[this.current];
      this.el.classList.add('emm-cs-change');
    }, this.interval);
  }
}

/* ── Auto-init au DOMContentLoaded ─── */
document.addEventListener('DOMContentLoaded', () => {
  /* Typewriter sur tous les éléments .emm-typewriter */
  document.querySelectorAll('.emm-typewriter').forEach(el => {
    const tw = new EmmeraTypewriter(el, { speed: el.dataset.speed ? +el.dataset.speed : 80 });
    /* Déclenche après un délai optionnel */
    const delay = el.dataset.delay ? +el.dataset.delay : 400;
    setTimeout(() => tw.write(), delay);
  });

  /* CounterScroll sur .emm-counter-scroll */
  document.querySelectorAll('.emm-counter-scroll').forEach(el => {
    const cs = new EmmeraCounterScroll(el);
    cs.start();
  });
});
